export const suggestCaratThreshold = 5;

export const SUBMISSION_MAX_PHOTO_SIZE_KB = 50000;
export const FILES_MAX_COUNT = 4;
export const QUALIFICATION_REJECTED = 2;
export default { suggestCaratThreshold };
